<template>
  <div
    class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
    id="page-login"
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col hidden lg:block lg:w-1/2">
              <img
                :src="require('./../../assets/images/pages/login.png').default"
                alt="login"
                class="mx-auto"
              />
         
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container">
                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">Login</h4>
                  <p>Welcome back, please login to your account.</p>
                </div>

                <div>
                  <vs-input
                    v-validate="'required|email|min:3'"
                    data-vv-validate-on="blur"
                    name="email"
                    label-placeholder="Email"
                    v-model="email"
                    class="w-full"
                  />
                  <span class="text-danger text-sm">{{
                    errors.first("email")
                  }}</span>

                  <vs-input
                    data-vv-validate-on="blur"
                    v-validate="'required|min:6|max:50'"
                    :type="type"
                    name="password"
                    label-placeholder="Password"
                    v-model="password"
                    class="w-full mt-6"
                  />
                  <span class="text-danger text-sm">{{
                    errors.first("password")
                  }}</span>

                  <i
                    style="border-left:0px;"
                    @click="type = type == 'password' ? 'text' : 'password'"
                    :class="[
                      type == 'password'
                        ? 'vs-icon vs-input--icon-custom vs-input--icon feather icon icon-eye icon-after'
                        : 'vs-icon vs-input--icon vs-input--icon-custom feather icon icon-eye-off icon-after'
                    ]"
                  ></i>
                  <!-- <feather-icon :icon="[type == 'password' ? 'EyeIcon' : 'EyeOffIcon']" @click="type = type == 'password' ? 'text' : 'password'" class="inline-block mr-2" svgClasses="w-4 h-4" /> -->

                  <div class="flex flex-wrap justify-between my-5">
                    <!-- <vs-checkbox v-model="checkbox_remember_me" class="mb-3"
                      >Remember Me</vs-checkbox
                    > -->
                    <router-link to="/forgot-password"
                      >Forgot Password?</router-link
                    >
                  </div>
                  <vs-button :disabled="!validateForm" @click="loginJWT"
                    >Login</vs-button
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: null,
      password: null,
      checkbox_remember_me: false,
      type: "password"
    };
  },
  computed: {
    validateForm() {
      return !this.errors.any() && this.email != null && this.password != null;
    }
  },
  methods: {
    checkLogin() {
      // If user is already logged in notify
      if (this.$store.state.auth.isUserLoggedIn()) {
        // Close animation if passed as payload
        this.$vs.loading.close();
        this.$vs.notify({
          title: "Login Attempt",
          text: "You are already logged in!",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning"
        });
        return;

        // return false;
      }
      return true;
    },
    loginJWT() {
      if (!this.checkLogin()) return;

      // Loading
      this.$vs.loading();

      const payload = {
        checkbox_remember_me: this.checkbox_remember_me,
        userDetails: {
          email: this.email,
          password: this.password
        }
      };

      this.$store
        .dispatch("auth/login", payload)
        .then(() => {
          this.$vs.loading.close();
        })
        .catch(error => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Error",
            text: error.message,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger"
          });
        });
    },
    registerUser() {
      if (!this.checkLogin()) return;
      this.$router.push("/pages/register").catch(() => {});
    }
  }
};
</script>

<style lang="scss">
.vs-input--icon-custom.feather {
  padding: 11.8rem 2.5rem 0rem 0.4rem;
}
#page-login {
  .social-login-buttons {
    .bg-facebook {
      background-color: #1551b1;
    }
    .bg-twitter {
      background-color: #00aaff;
    }
    .bg-google {
      background-color: #4285f4;
    }
    .bg-github {
      background-color: #333;
    }
  }
}
</style>